import axios from 'axios';
import { fetchParkinglotDetailsByEmpRegistrationId } from './parkinglotService';
const hostPath = process.env.REACT_APP_API_BASE_URL;
const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;

const deleteParkingLot = async (lot) => {
    const payload = {
        EmailId: lot.emailId,
        Parking_Lot_ID: lot.parking_Lot_ID,
    };
    const response = await axios.post(
        `${hostPath}/api/DeleteParkingLotDetailsByEmailId`,
        payload,
        { headers: { "x-functions-key": `${hostHeader}` } }
    );
    return response.data?.status === true;
};

const fetchBankDetailsByRegistrationId = async (registrationId) => {
    try {
        const response = await fetch(`${hostPath}/api/UpdateBankDetails/${registrationId}`, {
            headers: { "x-functions-key": `${hostHeader}` },
        });
        if (!response.ok) return [];
        const data = await response.json();
        return Array.isArray(data) ? data : [];
    } catch (error) {
        console.error('Failed to fetch employee bank details:', error);
        return [];
    }
};

const deleteBankDetail = async (bankDetailID) => {
    const response = await axios.delete(
        `${hostPath}/api/DeleteBankDetailById/${bankDetailID}`,
        { headers: { "x-functions-key": `${hostHeader}` } }
    );
    return response.data?.status === true;
};

export const deleteEmpByEmail = async (email, empId, empRegistrationID) => {
    if (!email) {
        return { success: false, message: 'Employee email is required to delete.' };
    }

    const deleteJson = { EmailId: String(email).toLowerCase() };
    if (empId != null && empId !== '') deleteJson.empId = empId;
    if (empRegistrationID != null && empRegistrationID !== '') {
        deleteJson.EmpRegistrationID = empRegistrationID;
    }

    try {
        const response = await axios.post(
            `${hostPath}/api/DeleteEmpBasedOnEmailId`, 
            deleteJson,
            {
                headers: { "x-functions-key": `${hostHeader}` },
            }
        );
        if (response.data) {
            if (response.data.status) {
                return { success: true, message: 'User has been deleted successfully!' };
            } else {
                return { success: false, message: response.data.responseMessage || 'Failed to delete employee.' };
            }
        } else {
            return { success: false, message: 'No response from the server. Please try again.' };
        }
    } catch (error) {
        console.error('Error during user deletion:', error);
        throw new Error(error?.response?.data?.responseMessage || 'Failed to delete user. Please try again later.');
    }
};

export const deleteEmployeeWithAllData = async (email, empId, empRegistrationID) => {
    try {
        if (empRegistrationID) {
            const parkingLots = await fetchParkinglotDetailsByEmpRegistrationId(empRegistrationID);
            for (const lot of parkingLots) {
                await deleteParkingLot(lot);
            }

            const bankDetails = await fetchBankDetailsByRegistrationId(empRegistrationID);
            for (const bank of bankDetails) {
                if (bank.bankDetailID) {
                    await deleteBankDetail(bank.bankDetailID);
                }
            }
        }

        return await deleteEmpByEmail(email, empId, empRegistrationID);
    } catch (error) {
        console.error('Error during employee cascade deletion:', error);
        throw new Error('Failed to delete employee and associated data. Please try again later.');
    }
};
export const empRegistration = async (reqbody) => {
    try {
        const response = await axios.post(
            `${hostPath}/api/EmployeeRegistration`,
            reqbody,
            { headers: { "x-functions-key": `${hostHeader}` } }
        );
        if (response.data.status) {
            return response.data;
        } else {
            return false;
        }
    } catch (error) {
        console.error('Error:', error);
        return false; 
    }
};

export const EmpRegistrationB2C = async (reqbody) => {
    try {
        console.log("enter inti the b2c");
        
        const response = await fetch(`${hostPath}/api/CreateEmployee`, {
          method: "POST",
          headers: {
            "x-functions-key": `${hostHeader}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(reqbody),
        });
        const data = await response.json();
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return data;
      } catch (error) {
        console.error("Failed to update user details:", error);
        throw error;
      }
};

export const fetchEmpDetailsByUserId = async (empId) => {
    try {
        const response = await fetch(`${hostPath}/api/GetEmpDetailsbyempid`, {
            method: 'POST',
            headers: { "x-functions-key": `${hostHeader}` },
            body: JSON.stringify({ empId }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        console.log("user data response",data);
        return data[0];  // Return the fetched user data
    } catch (error) {
        console.error('Failed to fetch user details:', error);
        throw error;  // Re-throw the error to handle it in the component
    }
};
export const fetchEmpDetailsByEmailId= async (EmailId) => {
    try {
        const response = await fetch(`${hostPath}/api/GetEmpDetails`, {
            method: 'POST',
            headers: { "x-functions-key": `${hostHeader}` },
            body: JSON.stringify({ EmailId }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        return data[0];  // Return the fetched user data
    } catch (error) {
        console.error('Failed to fetch user details:', error);
        throw error;  // Re-throw the error to handle it in the component
    }
};

export const UpdateProfileByEntity = async (reqbody) => {
    try {
        const response = await fetch(`${hostPath}/api/UpdateEmpDetailsByEntityid`, {
          method: "PUT",
          headers: {
            "x-functions-key": `${hostHeader}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(reqbody),
        });
        const data = await response.json();
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return data;
      } catch (error) {
        console.error("Failed to update user details:", error);
        throw error;
      }
};

export const fetchEmpDetails = async (EmpRegistrationID) => {
    try {
        const response = await fetch(`${hostPath}/api/GetEmpDetailsbyid`, {
            method: 'POST',
            headers: { "x-functions-key": `${hostHeader}` },
            body: JSON.stringify({ EmpRegistrationID }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        return data[0];  // Return the fetched user data
    } catch (error) {
        console.error('Failed to fetch user details:', error);
        throw error;  // Re-throw the error to handle it in the component
    }
};

export const UpdateProfileEmployee = async (reqbody) => {
    try {
        const response = await fetch(`${hostPath}/api/updateuserdetails`, {
          method: "PUT",
          headers: {
            "x-functions-key": `${hostHeader}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(reqbody),
        });
        const data = await response.json();
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return data;
      } catch (error) {
        console.error("Failed to update user details:", error);
        throw error;
      }
};